import { StepProps } from '../TimsurveyWizard'

export default function StepRiepilogo({ pratica, form, setForm, onNext }: StepProps) {
  return (
    <div className="card p-4 space-y-3">
      <div className="grid grid-cols-1 gap-2 text-sm">
        <div><span className="text-slate-500">Ragione sociale:</span> <strong>{pratica.ragione_sociale}</strong></div>
        <div><span className="text-slate-500">Indirizzo:</span> {pratica.indirizzo ?? '—'} {pratica.citta ?? ''}</div>
        <div><span className="text-slate-500">Referente cliente:</span> {pratica.referente_cliente ?? '—'}</div>
        <div><span className="text-slate-500">Referente OA:</span> {pratica.referente_oa ?? '—'}</div>
        <div><span className="text-slate-500">Referente vendita:</span> {pratica.referente_vendita ?? '—'}</div>
        <div><span className="text-slate-500">ID GRS:</span> {pratica.id_grs_site_survey ?? '—'}</div>
        <div><span className="text-slate-500">N° ODA:</span> {pratica.n_oda_sopralluogo ?? '—'}</div>
      </div>

      <div>
        <label className="label">Data e ora sopralluogo effettiva</label>
        <input
          type="datetime-local"
          className="input w-full"
          value={form.data_sopralluogo_effettiva}
          onChange={e => setForm(f => ({ ...f, data_sopralluogo_effettiva: e.target.value }))}
        />
      </div>

      <button className="btn-primary w-full" onClick={onNext}>Avanti</button>
    </div>
  )
}
